import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import useFetchAemBrspdContents from "../../../../../shared/hooks/useFetchAemBrspdContents";
import ApiUrls from "../../../Utils/axr";
import { errorConditionGTM } from "../../../Utils/googleTags";

type MyRewardsContentState = {
    myRewardsContent: any;
    loading: boolean;
    error: any;
}

const initialState: MyRewardsContentState = {
    myRewardsContent: null,
    loading: false,
    error: null,
};

const host = window?.location?.host;
const file = "my-rewards.json";

export const getMyRewardsContent = createAsyncThunk(
    "get/myRewards/content",
    async () => {
        try {
            const response = await useFetchAemBrspdContents({
                [ApiUrls.aem_content]: `${file}?appName=${host}`,
            });
            return response?.data;
        } catch (error) {
            throw error;
        }
    }
);

const myRewardsSlice = createSlice({
    name: "myRewards-content/Details",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getMyRewardsContent.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(getMyRewardsContent.fulfilled, (state, action) => {
            state.myRewardsContent = action.payload;
            state.loading = false;
            state.error = null;
        });
        builder.addCase(getMyRewardsContent.rejected, (state, action) => {
            errorConditionGTM(
                "BRSPD_MyRewards_EC_Flow",
                "myRewards-content",
                action?.error?.message,
                action?.type
            );
            state.myRewardsContent = null;
            state.loading = false;
            state.error = action.error;
        });
    },
});

export default myRewardsSlice.reducer;
